import { SvgIcon } from '../SvgIcon/SvgIcon'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo'
import Box from '@mui/material/Box'
import React from 'react'

interface InfoNoticeProps {
	content: string
	iconLeft?: boolean
	iconRight?: boolean
}

export const InfoNotice = (props: InfoNoticeProps) => {
	const { content, iconLeft, iconRight } = props

	return (
		<Box
			sx={{
				display: 'flex',
				gap: 1,
				padding: 0.5,
				backgroundColor: 'rgba(206, 212, 218, 0.35)',
				width: 'fit-content',
				mb: '0.5rem',
				mt: '0.5rem',
				whiteSpace: 'pre-line'
			}}
		>
			{iconLeft && <><SvgIcon icon={faCircleInfo} /></>}
			{content}
			{iconRight && <>&nbsp;<SvgIcon icon={faCircleInfo} /></>}
		</Box>
	)
}